import { SFXS } from "@orbital/games-frontend-library";
import { notifications } from "../../lib/plinko_notifications";

export const handler = (isClickable: boolean, handleAbove: (a: string) => string, handleNotification: (a: string) => string, audio: { sound: boolean }) => {
    if (isClickable) {
        if (audio.sound) SFXS.goForwardSFX.play()
        return handleAbove("Risks and Rows")
    } else {
        return handleNotification(notifications.cantChangeRiskOrRows);
    }
}